import React from "react";
import "../css/Footer.scss";

function Footer(){
    return <div className="w-100 rd-grid app_footer">
        <div className="rd-xs-12 footer_title">
            <span className="text-headline-5">DataPlus Solutions</span>
            <span className="text-headline-6">Portail de services de renseignement</span>
        </div>
        <div className="rd-xs-3">
            <div className="address">
                <span className="text-headline-6">Adresse</span>
                <span className="text-body-1">Godomey, xxxxxxxxxx</span>
                <span className="text-body-1">+229 90 06 XX XX</span>
            </div>
        </div>
        <div className="rd-xs-3">
            <div className="address">
                <span className="text-headline-6">Services</span>
                <span className="text-body-1">Collecte de données</span>
                <span className="text-body-1">Sondage d'opinion</span>
                <span className="text-body-1">Vérification d'informations</span>
            </div>
        </div>
        <div className="rd-xs-3">
            <div className="address">
                <span className="text-headline-6">Carriere</span>
                <span className="text-body-1">Offres d'emploi</span>
                <span className="text-body-1">Devenir un collecteur</span>
            </div>
        </div>
        <div className="rd-xs-3">
            <div className="address">
                <span className="text-body-1">Service client</span>
                <span className="text-headline-6">FAQ</span>
            </div>
        </div>
        <span className="rd-xs-12 text-caption-1">Filiale de HUBBLE BENIN</span>
    </div>
}

export default Footer;